(function () {
  'use strict';

  angular.module('app').component('clientContactList', clientContactList());

  function clientContactList() {
    return {
      bindings: {
        client: '=',
        clientContacts: '=',
        // onClientContactSaved: '&'
      },
      controller: ClientContactListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/clients/client-contacts/client-contact-list/client-contact-list.component.html',
    };
  }

  ClientContactListComponent.$inject = ['UtilService', 'AbilityService', 'ClientContactService'];

  function ClientContactListComponent(UtilService, AbilityService, ClientContactService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_client_accountadmin'),
      canShow: AbilityService.can('show_client_accountadmin'),
      canUpdate: AbilityService.can('update_client_accountadmin'),
      canDestroy: AbilityService.can('destroy_client_accountadmin'),
    };

    var fastCreation = false;

    // Methods
    vm.addClientContact = addClientContact;
    vm.showClientContact = showClientContact;
    vm.changeClientContactStatus = changeClientContactStatus;
    vm.changeClientContactDefault = changeClientContactDefault;
    vm.deleteClientContact = deleteClientContact;

    vm.$onInit = function () {
      checkDefaultClientContact();
    };

    function addClientContact() {
      if (!vm.permissions.canCreate) {
        return;
      }

      var successCallback = function (selectedItem) {
        vm.clientContacts.push(selectedItem);
        vm.UtilService.itemListChanged(selectedItem.id);

        // vm.onClientContactSaved();
        checkDefaultClientContact();
      };

      ClientContactService.openClientContactModal(
        {},
        vm.client,
        'create',
        fastCreation,
        successCallback
      );
    }

    function showClientContact(clientContact, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      var successCallback = function (response) {
        // vm.onClientContactSaved();
      };

      ClientContactService.openClientContactModal(
        clientContact,
        vm.client,
        mode,
        fastCreation,
        successCallback
      );
    }

    function changeClientContactStatus(clientContact) {
      if (!vm.permissions.canUpdate || clientContact.is_default) {
        return;
      }

      ClientContactService.changeClientContactStatus(clientContact, vm.client.id);
    }

    function changeClientContactDefault(clientContact) {
      if (!vm.permissions.canUpdate || clientContact.is_default) {
        return;
      }

      var successCallback = function () {
        vm.clientContacts.forEach(function (contact) {
          contact.is_default = false;

          if (contact.id === clientContact.id) {
            contact.is_default = true;
          }
        });

        // clientContact.is_default = true;

        checkDefaultClientContact();
      };

      ClientContactService.changeClientContactDefault(clientContact, successCallback);
    }

    function deleteClientContact(clientContact, index) {
      if (!vm.permissions.canDestroy || clientContact.is_default) {
        return;
      }

      var successCallback = function (index) {
        vm.clientContacts.splice(index, 1);
      };

      ClientContactService.deleteClientContact(clientContact, vm.client.id, successCallback, index);
    }

    function checkDefaultClientContact() {
      for (var i = 0; i < vm.clientContacts.length; i++) {
        if (vm.clientContacts[i].is_default) {
          vm.errorDefaultClientContact = false;
          return;
        }
      }

      vm.errorDefaultClientContact = true;
    }
  }
})();
